module.exports = __webpack_public_path__ + "static/media/icon-door-closed.0327e9ac.svg";